import { render } from "./DetailsOrders.vue?vue&type=template&id=99bd1748"
import script from "./DetailsOrders.vue?vue&type=script&lang=js"
export * from "./DetailsOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__